import {DocumentType} from '../enum/document-type';
import {DocumentLevel} from "../enum/document-level";

export class DocumentDto {

  public id: number | null;

  public expirationDate: Date;

  public name: string;

  public level: DocumentLevel;

  public achievementDate: Date;

  public validityDuration: string | null;

  public isValid: boolean;

  public type: DocumentType;

  constructor(id: number | null, expirationDate: Date, name: string, level: DocumentLevel, achievementDate: Date, validityDuration: string | null, isValid: boolean, type: DocumentType) {
    this.id = id;
    this.expirationDate = expirationDate;
    this.name = name;
    this.level = level;
    this.achievementDate = achievementDate;
    this.validityDuration = validityDuration;
    this.isValid = isValid;
    this.type = type;
  }
}
